import Modal from './modules/modal.js'; //quite
import Tabs from './modules/tabs.js'; //quite
//import * as Swiper from './modules/swiper.js'; //quite
import objectFitImages from './extern/ofi.min.js'; //quite

//Touch sniffer
if ('ontouchstart' in document.documentElement) {
	document.querySelector('html').classList.add('is-touch');
}

// Hamburger menu
var $body = document.querySelector('body');
var $hamburger = document.querySelectorAll('.site-hamburger');

$hamburger &&
	[...$hamburger].forEach((el) => {
		el.addEventListener('click', function (e) {
			el.parentElement.parentElement.classList.toggle('nav-open');
			//$body.classList.toggle("nav-open");
		});
	});

let prevScrollpos = window.pageYOffset;
const header = document.querySelector('.site-header--scroll');
window.onscroll = function () {
	const currentScrollPos = window.pageYOffset;

	if (prevScrollpos > currentScrollPos) {
		if (currentScrollPos > 200) {
			header.dataset.active = true;
		} else {
			delete header.dataset.active;
		}
	} else {
		setTimeout(() => {
			delete header.dataset.active;
		}, 600);
	}
	prevScrollpos = currentScrollPos;
};

jQuery(document).ready(function ($) {
	objectFitImages();

	new Modal();

	if (document.querySelector('.tabs')) {
		new Tabs();
	}

	function filterProducts(object, url, type) {
		var selectedId = object.attr('value');
		var urlVars = getUrlVars();

		if (urlVars['page']) {
			urlVars['page'] = '1';
		}

		if (object.is(':checked')) {
			if (urlVars[type]) {
				urlVars[type] += selectedId + ',';
			} else {
				urlVars[type] = ',' + selectedId + ',';
			}
		} else {
			if (urlVars[type]) {
				urlVars[type] = urlVars[type].replace(
					new RegExp(',' + selectedId + ',', 'g'),
					','
				);
			}
		}

		window.location = buildProductFilterUrl(url, urlVars);
	}

	function filterProductsByPrice(minimum, maximum, url) {
		var urlVars = getUrlVars();

		if (urlVars['page']) {
			urlVars['page'] = '1';
		}

		urlVars['price'] = minimum + ',' + maximum;

		window.location = buildProductFilterUrl(url, urlVars);
	}

	function buildProductFilterUrl(url, urlVars) {
		var first = true;

		$.each(urlVars, function (key, value) {
			if (value.length > 0) {
				if (first) {
					url += '?';
					first = false;
				} else {
					url += '&';
				}

				url += key + '=' + value;
			}
		});

		return url;
	}

	function getUrlVars() {
		var vars = {};

		if (window.location.search) {
			var hash;
			var hashes = window.location.href
				.slice(window.location.href.indexOf('?') + 1)
				.split('&');

			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars[hash[0]] = hash[1];
			}
		}

		return vars;
	}

	function filter(form) {
		var filter = $(form);
		var baseUrl = location.protocol + '//' + location.host + location.pathname;
		var ajaxUrl =
			location.protocol +
			'//' +
			location.host +
			'/grafityp/' +
			filter.find('input[type="hidden"]').val() +
			'/';

		var formData = {
			category: [],
			duration: [],
			glue: [],
			glue_color: [],
			location: [],
			surface: [],
			substrate: [],
			method: [],
			composition: [],
			view: []
		};

		$.each(formData, function (key, val) {
			filter.find('input[name="' + key + '[]"]:checked').each(function () {
				val.push($(this).val());
			});
		});

		var new_url = buildProductFilterUrl(baseUrl, formData);
		var ajaxCall = buildProductFilterUrl(ajaxUrl, formData);

		$.ajax({
			url: ajaxCall,
			type: 'GET', // POST
			beforeSend: function (xhr) {
				$('#response').addClass('loading');
			},
			success: function (response) {
				$('#response').html(response).removeClass('loading'); // insert data
				window.history.replaceState(null, 'filter', new_url);
			}
		});

		return formData;
	}

	$('#filter-form').submit(function (e) {
		return false;
	});

	$('.filter-group input[type=checkbox]').on('change', function (e) {
		e.preventDefault();
		e.stopPropagation();
		/* Act on the event */
		setTimeout(function () {
			filter('#filter');
		}, 300);

		return false;
	});
});

var featureSwiper = new Swiper('.feature-swiper', {
	// Optional parameters
	loop: true,

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	}
});

var productSwiper = new Swiper('.product-swiper', {
	// Optional parameters
	loop: true,
	slidesPerView: 1.5,
	spaceBetween: 30,
	slidesOffsetBefore: 0,
	slidesOffsetAfter: 15,

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev'
	},
	breakpoints: {
		540: {
			slidesPerView: 2.5,
			slidesOffsetAfter: 15
		},
		768: {
			slidesPerView: 3.5,
			slidesOffsetAfter: 50
		},
		992: {
			slidesPerView: 4.5,
			slidesOffsetAfter: 100
		}
	}
});

const alert = document.querySelector('#alert');

// if( alert && sessionStorage.getItem('alertState') != 'closed' ) {

//   setTimeout(() => {

//     document.body.classList.add("modal-body");
//     alert.classList.add("modal-visible");

//     alert.addEventListener("transitionend", function(e) {
//       if (
//         "opacity" === e.currentTarget.propertyName &&
//         e.currentTarget.classList.contains("modal-visible")
//         ) {
//           e.currentTarget.querySelector(".modal-inner").classList.add("modal-reveal");
//         }
//       });

//   }, 1000);

//   document.querySelector( '#alert .modal-close' ).addEventListener( 'click', function() {
//     sessionStorage.setItem('alertState','closed');
//   });
// }

function setAlertState() {
	sessionStorage.setItem('alertState', 'closed');
}

if (alert) {
	setTimeout(() => {
		document.body.classList.add('modal-body');
		alert.classList.add('modal-visible');

		alert.addEventListener('transitionend', function (e) {
			if (
				'opacity' === e.currentTarget.propertyName &&
				e.currentTarget.classList.contains('modal-visible')
			) {
				e.currentTarget
					.querySelector('.modal-inner')
					.classList.add('modal-reveal');
			}
		});
	}, 1000);

	document
		.querySelector('#alert .modal-close')
		.addEventListener('click', setAlertState);

	const alertLinks = document.querySelectorAll('#alert a');
	alertLinks.forEach((alertLink) =>
		alertLink.addEventListener('click', setAlertState)
	);
}
